import { Http } from '@mygpt/app/http';
import type {
  QuestionTagGroupPayload,
  QuestionTagGroupOut,
  SessionMessageUpdateTags,
  SessionMessageExportOut,
} from '@mygpt/types/tag';

/**
 * 创建标签组
 * @param robotId 机器人ID
 * @param payload 标签组数据
 * @returns
 */
export const createTagGroup = (robotId: string, payload: QuestionTagGroupPayload) => {
  const { post } = Http.use();
  return post<QuestionTagGroupOut>(`/robots/${robotId}/tag-groups`, payload);
};

/**
 * 获取标签组列表
 * @param robotId 机器人ID
 * @param includeDeleted 是否包含已删除的标签组，默认为false
 * @returns
 */
export const getTagGroups = (robotId: string, includeDeleted = false) => {
  const { get } = Http.use();
  const params = includeDeleted ? { include_deleted: includeDeleted } : {};
  return get<QuestionTagGroupOut[]>(`/robots/${robotId}/tag-groups`, { params });
};

/**
 * 更新标签组
 * @param robotId 机器人ID
 * @param groupId 标签组ID
 * @param payload 标签组数据
 * @returns
 */
export const updateTagGroup = (robotId: string, groupId: string, payload: QuestionTagGroupPayload) => {
  const { put } = Http.use();
  return put<QuestionTagGroupOut>(`/robots/${robotId}/tag-groups/${groupId}`, payload);
};

/**
 * 删除标签组
 * @param robotId 机器人ID
 * @param groupId 标签组ID
 * @returns
 */
export const deleteTagGroup = (robotId: string, groupId: string) => {
  const { delete: del } = Http.use();
  return del(`/robots/${robotId}/tag-groups/${groupId}`);
};

/**
 * 更新消息标签
 * @param robotId 机器人ID
 * @param messageId 消息ID
 * @param payload 标签ID列表
 * @returns
 */
export const updateMessageTags = (robotId: string, messageId: string, payload: SessionMessageUpdateTags) => {
  const { put } = Http.use();
  return put(`/robots/${robotId}/messages/${messageId}/tags`, payload);
};

/**
 * 导出带标签的消息记录
 * @param robotId 机器人ID
 * @returns
 */
export const exportTaggedMessages = (robotId: string) => {
  const { get } = Http.use();
  return get<SessionMessageExportOut[]>(`/robots/${robotId}/export/messages`);
};

/**
 * 删除单个标签
 * @param robotId 机器人ID
 * @param tagId 标签ID
 * @returns
 */
export const deleteTag = (robotId: string, tagId: string) => {
  const { delete: del } = Http.use();
  return del(`/robots/${robotId}/tags/${tagId}`);
};

/**
 * 重新分类消息 (使用LLM)
 * @param robotId 机器人ID
 * @param messageId 消息ID
 * @returns
 */
export const reclassifyMessage = (robotId: string, messageId: string) => {
  const { post } = Http.use();
  return post(`/robots/${robotId}/messages/${messageId}/reclassify`);
};
